import { NotificationSeverity } from "./bands/notification/types"

export type { NotificationSeverity }
